module.exports = __webpack_public_path__ + "img/logo-dark_old.a5a6af2c.png";